import styled from 'styled-components';

export const CommentWrapper = styled.div`
  padding: 0.5rem 0;
`;

export const FormWrapper = styled.div`
  margin-top: 1rem;
`;
